import {
  INSTAGRAM_PHOTO_LIST_REQUEST,
  INSTAGRAM_PHOTO_LIST_SUCCESS,
  INSTAGRAM_PHOTO_LIST_FAIL,
} from "../Constants/InstagramPhotoConstants";

const initialState = {
  loading: false,
  photos: [],
  fetchedAt: null,
  error: null,
};

export const instagramPhotoStoreListReducer = (state = initialState, action) => {
  switch (action.type) {
    case INSTAGRAM_PHOTO_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case INSTAGRAM_PHOTO_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        photos: action.payload,
        fetchedAt: Date.now(),
      };
    case INSTAGRAM_PHOTO_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};